/* eslint-disable indent */
import React, { useContext } from 'react'
import { Text, Header3 } from '../../styles/Components'
import GiftCardContext from './GiftCardContext'
import GroupSelector from '../group-selector'
import { gsColors } from '../../styles/Variables'

const PackageOptions = () => {
  const {
    state: { selectedGroup, groups, selectedProduct, selectedProductError },
    dispatch,
  } = useContext(GiftCardContext)

  const handleClick = (p) => {
    dispatch({ type: 'SET_SELECTED_PRODUCT', package: p })
  }

  return (
    <div
      data-testid="package-option-container"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <GroupSelector
        groups={groups}
        selectedGroup={selectedGroup}
        setSelectedGroup={(group) =>
          dispatch({ type: 'SET_SELECTED_GROUP', group })
        }
      />
      <div className="package-container">
        {selectedGroup &&
          groups[selectedGroup] &&
          groups[selectedGroup].map((p) => {
            return (
              <button
                key={p.id}
                className={`gift-card-package-card ${selectedProduct && selectedProduct.id === p.id
                  ? 'selected'
                  : ''
                  }`}
                data-testid="select-package-button"
                onClick={() => handleClick(p)}
              >
                <div className="package-card-top">
                  <Header3>{p.name}</Header3>
                  <Text variant="medium">${p.price}</Text>
                </div>
                <div className="package-card-bottom">
                  <div>
                    <Header3 fontSize={18} color={gsColors.cobalt}>
                      {p.discountLabel}
                    </Header3>
                    <Text fontSize={18} align="left">
                      {p.description}
                    </Text>
                  </div>
                </div>
              </button>
            )
          })}
      </div>
      {selectedProductError && (
        <Text
          variant="small"
          color={gsColors.errorRed}
          margin="8px 0 0"
          className="error-text"
          align="center"
        >
          Please select a package
        </Text>
      )}
    </div>
  )
}

export default PackageOptions
